'use strict';exports.__esModule = true;exports.gtagSendEvent = exports.gaTrackEcommerce = exports.gaSetTimedEvent = exports.gaTrackEvent = exports.gaSetData = exports.gaTrackModalOpen = exports.gaTrackPage = exports.initGA = exports.initGTM = undefined;var _reactGa = require('react-ga');var _reactGa2 = _interopRequireDefault(_reactGa);
var _reactGtmModule = require('react-gtm-module');var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);
var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var tagManagerArgs = {
  gtmId: _constants.analytics.google.tagManagerId };


function gtag() {
  global.dataLayer = global.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  global.dataLayer && global.dataLayer.push(arguments);
}

var initGTM = exports.initGTM = function initGTM() {
  // googleTagLoader().then(() => {
  //   if (!global) { return; }
  //
  //   global.dataLayer = global.dataLayer || [];
  //
  //   gtag('js', new Date());
  //   gtag('config', analytics.google.trackingId);
  // });

  _reactGtmModule2.default.initialize(tagManagerArgs);
};

var initGA = exports.initGA = function initGA() {
  _reactGa2.default.initialize(_constants.analytics.google.trackingId);
};

var gaTrackPage = exports.gaTrackPage = function gaTrackPage(page) {
  if (page) {
    _reactGa2.default.set({ page: page });
    _reactGa2.default.pageview(page);
  } else {
    _reactGa2.default.set({ page: window.location.pathname, title: document.title });
    _reactGa2.default.pageview(window.location.pathname);
  }
};

/**
    * @param {string} modalType
    */
var gaTrackModalOpen = exports.gaTrackModalOpen = function gaTrackModalOpen(modalType) {
  _reactGa2.default.modalview(modalType);
};

/**
    * {object} @param data
    */
var gaSetData = exports.gaSetData = function gaSetData(data) {
  _reactGa2.default.set(data);
};

/**
    * {object} @param data
    */
var gaTrackEvent = exports.gaTrackEvent = function gaTrackEvent(data) {
  _reactGa2.default.event(data);
};

var gaSetTimedEvent = exports.gaSetTimedEvent = function gaSetTimedEvent(_ref) {var page = _ref.page,time = _ref.time,label = _ref.label;
  _reactGa2.default.timing({
    category: 'User',
    variable: page,
    value: time,
    label: label });

};

var gaTrackEcommerce = exports.gaTrackEcommerce = function gaTrackEcommerce(id, name, price, tax, category, quantity) {
  _reactGa2.default.plugin.require('ecommerce');
  _reactGa2.default.plugin.execute('ecommerce', 'addItem', {
    id: id,
    name: name,
    sku: '--', // seems to be required
    price: price,
    tax: tax,
    category: category,
    quantity: quantity });

  _reactGa2.default.plugin.execute('ecommerce', 'addTransaction', {
    id: id, // the same as for addItem to connect them
    revenue: price,
    tax: tax,
    currency: 'ILS' });

  _reactGa2.default.plugin.execute('ecommerce', 'send');
  _reactGa2.default.plugin.execute('ecommerce', 'clear');
};


var gtagSendEvent = exports.gtagSendEvent = function gtagSendEvent(_ref2) {var name = _ref2.name,category = _ref2.category,action = _ref2.action,label = _ref2.label,value = _ref2.value,transactionId = _ref2.transactionId,item = _ref2.item;
  gtag('event', name, {
    send_to: _constants.analytics.google.trackingId,
    event_category: category,
    event_action: action,
    event_label: label,
    transaction_id: transactionId,
    value: value,
    item: item });

};


//////////////////
// WEBPACK FOOTER
// ./src/utils/analytics/google.js
// module id = 588
// module chunks = 0